export const PACKAGES_VOLUME_CHART_ENDPOINT = '/package-api/chart/v1/packages-volume';
export const PACKAGE_TIMERS_DURATION_CHART_ENDPOINT = '/package-api/chart/v1/package-timers-duration';
